module.exports = __webpack_public_path__ + "b3a79cfb6fb6d2224c9016848caf5d61.png";